import SharedTimeInput from '../shared/TimeInput/SharedTimeInput';

import {
  addMissingMandatoryField,
  removeMissingMandatoryField,
  addRemark,
  removeRemark,
  updateRemark,
  addFile,
  removeFile,
} from 'reducers/autoPersonalFormReducer';

import type { MessageProps } from '../shared/Message/Message.types';

interface AutoTimeInputProps {
  section: number;
  label: string;
  value: string;
  onChange: (time: string) => void;
  message?: Omit<MessageProps, 'section'> & { section?: number };
  required?: boolean;
  subLabel?: string;
  disabled?: boolean;
}

const AutoTimeInput = (props: AutoTimeInputProps) => {
  const formActions = {
    addMissingMandatoryField,
    removeMissingMandatoryField,
    addRemark,
    removeRemark,
    updateRemark,
    addFile,
    removeFile,
  };

  return (
    <SharedTimeInput
      {...props}
      formStateKey="autoPersonalForm"
      formActions={formActions}
    />
  );
};

export default AutoTimeInput;
